//Componentes generales
import React, { useState, useMemo, useEffect, useContext } from 'react';
import { FixedSizeList } from 'react-window';
import { useNavigate } from 'react-router-dom';
import AddItm from '../addItm/AddItm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowUp } from '@fortawesome/free-solid-svg-icons';

//Componentes generales
import SearchInput from '../../components/searchInput/SearchInput';
import StateChange from '../../components/StateChange/StateChange';
import GruposChange from '../GruposChange.js/GruposChange';
import ReqInfo from '../ReqInfo/ReqInfo';
import FilterScreen from '../filterScreen/FilterScreen';
import AddFilter from '../addFilter/AddFilter';
import FormReq from '../FormReq/FormReq';
import RenderRow from '../renderRows/RRReqs';
import Swal from 'sweetalert2';
import { deleteTransactionDocument } from '../../api/transactionDocuments';

//Context
import controlContext from '../../context/control/controlContext';
import authContext from '../../context/authentication/authContex';
import windowSizeContext from '../../context/windowSize/windowSizeContext';

//Estilos
import './ReqList.css';

//Estados
import { STATES_COMPROBANTE } from '../../utils/states';

//Rutas
import Routes_gral from '../../utils/Routes_gral';

//Pending file para drop zone
import { setPendingFile } from '../../utils/pendingFile';

//Fecha y hora formateadas
import { getNewFormattedDate } from '../../utils/formatDate';

/* 
    Componente encargado de mostrar el listado de comprobante.
        Donde currentUser es el usuario en sesión.
              listTDoc es la lista de comprobante.
              modificarEstado es la función del context encargarda de realizar una modificación de un campo especifico.
              verDetalle es la función que recupera el detalle de un comprobante.
              filtros es el filtro donde se aplican las modificaciones por el usuario.
              aplicarFiltros es la función del context que aplica los filtros.
              productList es la lista de productos disponibles.
              generaPDF es la función del context que genera y descarga un archivo pdf.
              checkPermisos es la función del context que chequea si el usuario en sesión tiene permisos.
              guardarComo es la función del context encargada de guardar un comprobante generado por un "repetir".
              editar es la función del context encargada de guardar un comprobante generado por un "editar".
              eventoClickEdicion en la función del context que recupera los datos de un comprobante a editar.
              recuperaFilesDetalle es la función del context que recupera los archivos de un comprobante.
              sendToAPI es la función del context que envia la solicitud de enviar el comprobante a Softland.
*/
function ReqList({
  proveedores,
  listTDoc,
  modificarEstado,
  modificarGrupos,
  verDetalle,
  filtros,
  aplicarFiltros,
  productList,
  generaPDF,
  checkPermisos,
  guardarComo,
  editar,
  eventoClickEdicion,
  recuperaFilesDetalle,
  sendToAPI,
  countPendientes,
}) {
  //state para marcar el comprobante seleccionado.
  const [selected, setSelected] = useState('');
  //state para mostrar dialog de Edición.
  const [selectedEdit, setSelectedEdit] = useState('');
  //state para mostrar dialog de cambio de Estado.
  const [selectedState, setSelectedState] = useState('');
  //state para mostrar dialog de cambio de Grupo.
  const [selectedGrupos, setSelectedGrupos] = useState('');
  //state para mostrar dialog de cambio de Grupo.
  const [gruposComprobanteSelected, setGruposComprobanteSelected] = useState(
    []
  );
  //state para mostrar dialog de filtro.
  const [selectedFilter, setSelectedFilter] = useState('');
  //state para mostrar dialog de formulario comprobante (guardar como).
  const [selectedRepeat, setSelectedRepeat] = useState('');
  //state para filtros.
  const [filter, setFilter] = useState('');
  //state para definir estados no enviables.
  const [stateNoEnviables, setStatesNoEnviable] = useState([
    'PENDIENTE',
    'RECHAZADO',
  ]);

  /*state para deshabilitar botones hasta que termine de cargar el componente con los comprobantes */
  const [disabledElements, setDisabledElements] = useState(true);
  //state para saber si se modificaron los filtros
  const [filtrosModificados, setFiltrosModificados] = useState(false);
  //state para definir tamaño para lista.
  const [itemSize, setItemSize] = useState(240);
  //state para feedback visual del drop zone.
  const [isDragging, setIsDragging] = useState(false);

  //state titulo del dialog a utilizar.
  const [title, setTitle] = useState('');

  const navigate = useNavigate();

  //Context control comprobantes
  const cContext = useContext(controlContext);
  const { iniciarFiltros, activeWorkSpace, setActiveWorkSpace } = cContext;

  //Context auth
  const aContext = useContext(authContext);
  const { usuario, globalSettings } = aContext;

  const isProfileProv = usuario?.nroCta && usuario.nroCta.trim() !== "";
  const aiExtractionEnabled =
    globalSettings?.reemplazaValidacionPorExtraccion === true &&
    (!isProfileProv || globalSettings?.extraccionAplicaProveedores === true);

  // Calcula el valor del height según el tamaño de la pantalla y el tamaño del navbar
  const wSContext = useContext(windowSizeContext);
  let { height } = wSContext;

  useEffect(() => {
    const fn = async () => {
      await handlerIniciarlizarFiltros(activeWorkSpace);
    };
    fn();
  }, []);

  useEffect(() => {
    const fn = async () => {
      const workSpace = {
        pendientes: 1,
        autorizados: 0,
        todos: 0,
      };
      setActiveWorkSpace(workSpace);
      await handlerIniciarlizarFiltros(workSpace);
    };
    fn();
  }, [usuario]);

  const handlerIniciarlizarFiltros = async activeWorkSpace => {
    setDisabledElements(true);
    await iniciarFiltros(activeWorkSpace, usuario);
    setTimeout(() => {
      setDisabledElements(false);
    }, 1000);
  };

  /* 
        Manejador que setea el  filtro de busqueda.
            Donde data es lo ingresado por el usuario.
    */
  const handdlerSearchInput = data => {
    setFilter(data);
  };

  /* 
        Manejador que abre/cierra dialog de información del comprobante seleccionado.
            Donde item es el comprobante seleccionado.
        En este punto, se recuperan los archivos adjuntados al comprobante.
    */
  const handlerDetails = async item => {
    setSelected(null);
    if (item) {
      const files = await recuperaFilesDetalle(item);
      setSelected({ item, files });
    }
  };

  /* 
        Función encargada de mostrar el dialog de formulario de comprobante.
            Donde item es el comprobante del que se hace un guardar como.
                  prods es la lista de productos del comprobante.
                  agregaItemF es la función de agrega itm (No esta en uso).
        Se setea el estado del comprobante como pendieente y se agrega al titulo el prefijo "Copia" junto al numero del comprobante repetido.
    */
  const repeat = async (item, prods, agregaItemF) => {
    setSelectedRepeat(null);
    if (item) {
      const { tDocCodFor, tDocNroFor, tDocCodForDescrp, _id, ...rest } = item;
      const nuevaListaP = prods.map(p => {
        const { _id, ...rest } = p;
        return rest;
      });
      setSelectedRepeat({
        item: {
          ...rest,
          tDocCodFor,
          tDocCodForDescrp,
          codOri: '',
          state: 'PENDIENTE',
          enviado: false,
          fecAlt: getNewFormattedDate(),
          fecMod: getNewFormattedDate(),
          notePriv: '',
          notePubl: '',
          observ: '',
          observada: false,
          motivoObserv: '',
        },
        nuevaListaP,
        agregaItemF,
      });
    }
  };

  /* 
        Manejador que abre/cierra el dialog de formulario en modo guardar como.
            Donde item es el comprobante.
    */
  const handlerRepeat = async item => {
    setSelectedRepeat(null);
    if (item) {
      setSelectedRepeat(item);
      guardarComo(item);
    }
  };

  /* 
        Manejador que abre/cierra el dialog de formulario en modo edición.
            Donde req es el comprobante a editar.
                  agregaItemF es la función de agrega itm (No esta en uso).
        En este punto se recuperan los items y archivos.
    */
  const handlerEdit = async (req, agregaItemF) => {
    setSelectedEdit(null);
    if (req) {
      const { items, files } = await eventoClickEdicion(req);
      const { ...rest } = req;
      const nuevaListaP = items.map(p => {
        const { ...rest } = p;
        return rest;
      });
      setSelectedEdit({ req: { ...rest }, nuevaListaP, agregaItemF, files });
    }
  };

  const handlerState = async item => {
    setSelectedState(item);
  };

  const handlerGrupos = async item => {
    if (item !== null && item !== undefined) {
      const gruposComprobante = item.gruposV.map(grupo => {
        return { value: grupo._id, label: grupo.name };
      });
      setGruposComprobanteSelected(gruposComprobante);
    }
    setSelectedGrupos(item);
  };

  const handlerDelete = async (tDoc) => {
    const result = await Swal.fire({
      title: `Eliminar comprobante ${tDoc.codOri}?`,
      showDenyButton: true,
      confirmButtonText: 'Si, estoy seguro',
      confirmButtonColor: '#ff0000',
      denyButtonColor: '#3d4d87',
      denyButtonText: 'No',
    });
    if (result.isConfirmed) {
      try {
        await deleteTransactionDocument(tDoc);
        Swal.fire({ title: 'Comprobante eliminado', icon: 'success' });
        window.location.reload();
      } catch (error) {
        Swal.fire({ title: 'Error', text: 'No se pudo eliminar el comprobante', icon: 'error' });
      }
    }
  };

  const handlerClickFilter = itm => {
    setSelectedFilter(itm);
  };

  /* 
        Manejador encargado de abrir en una nueva ventana el archivo seleccionado.
    */
  const handlerAbrirURL = url => {
    window.open(url);
  };

  const handleWorkSpace = async statusToDisplay => {
    setFilter('');
    let workspaceToSet =
      statusToDisplay == 'todos'
        ? { todos: 1, autorizados: 0, pendientes: 0 }
        : statusToDisplay == 'autorizados'
        ? { todos: 0, autorizados: 1, pendientes: 0 }
        : { todos: 0, autorizados: 0, pendientes: 1 };
    let estado =
      statusToDisplay == 'todos'
        ? ['PENDIENTE', 'RECHAZADO', 'AUTORIZADO']
        : statusToDisplay == 'pendientes'
        ? ['PENDIENTE']
        : ['AUTORIZADO'];
    setActiveWorkSpace(workspaceToSet);
    if (filtrosModificados === true) {
      await handlerIniciarlizarFiltros(workspaceToSet);
      setFiltrosModificados(false);
    } else {
      const filterEstado = { ...filtros.filtrosEstado, state: estado };
      const filterRango = filtros.filtrosRango;
      await aplicarFiltros({ filterRango, filterEstado }, '');
    }
  };

  /*
        Manejadores de drag & drop sobre el botón "Agregar comprobante".
        Permite soltar un archivo PDF/JPG para navegar a /addReq con escaneo automático.
    */
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (!file) return;
    const allowedTypes = ['application/pdf', 'image/jpeg'];
    const allowedExtensions = ['pdf', 'jpg', 'jpeg'];
    const ext = file.name.split('.').pop().toLowerCase();
    if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(ext)) return;
    setPendingFile(file);
    setTitle('Agregar Comprobante');
    navigate(Routes_gral.addReq);
  };

  /*
        Función que determina si mostrar el formulario para agregar un nuevo comprobante.
        Se setea el titulo encabezado del formulario.
    */
  const enviarAgregar = () => {
    setTitle('Agregar Comprobante');
    navigate(Routes_gral.addReq);
  };

  return (
    <>
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '0px',
        }}
      >
        {aiExtractionEnabled && (
        <div
          className={`dropzone-container${isDragging ? ' dragging' : ''}`}
          style={{ position: 'absolute', left: 'calc(77% - 4cm)', top: '-60px' }}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <div className="dropzone-label">
            <FontAwesomeIcon className="dropzone-label-icon" icon={faFileArrowUp} />
            <span className="dropzone-label-text">
              {isDragging ? 'Soltar archivo aqui' : 'Arrastre un PDF o JPG'}
            </span>
          </div>
        </div>
        )}
        <div style={{ position: 'absolute', left: '77%', top: '-65px' }}>
          <AddItm
            titulo="Agregar comprobante"
            anadiritm={enviarAgregar}
          />
        </div>
      </div>
      <div className="mainContainerReqList">
        <div className="navbar-reqList">
          <div
            className={`${
              activeWorkSpace.pendientes
                ? 'navbar-container-reqList-active'
                : 'navbar-container-reqList'
            } ${disabledElements ? 'navbar-container-disabled' : ''}`}
            onClick={async () =>
              !disabledElements ? await handleWorkSpace('pendientes') : null
            }
          >
            <div className="navbar-item-reqList">
              <div className="navbar-item-label-xx">
                PENDIENTES
                {!disabledElements && (
                  <span
                    className={
                      'badge ' +
                      (countPendientes > 0
                        ? 'badge-pendientes'
                        : 'badge-pendientes-ok')
                    }
                  >
                    {countPendientes}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div
            className={`${
              activeWorkSpace.autorizados
                ? 'navbar-container-reqList-active'
                : 'navbar-container-reqList'
            } ${disabledElements ? 'navbar-container-disabled' : ''}`}
            onClick={async () =>
              !disabledElements ? await handleWorkSpace('autorizados') : null
            }
          >
            <div className="navbar-item-reqList">
              <div className="navbar-item-label-xx">AUTORIZADOS</div>
            </div>
          </div>
          <div
            className={`${
              activeWorkSpace.todos
                ? 'navbar-container-reqList-active'
                : 'navbar-container-reqList'
            } ${disabledElements ? 'navbar-container-disabled' : ''}`}
            onClick={async () =>
              !disabledElements ? await handleWorkSpace('todos') : null
            }
          >
            <div className="navbar-item-reqList">
              <div className="navbar-item-label-xx">TODOS</div>
            </div>
          </div>
        </div>
        <div className="container-requests-list">
          <FilterScreen
            verFiltro={handlerClickFilter}
            disabled={disabledElements}
          />
          <SearchInput
            defaultValue={filter}
            buscar={handdlerSearchInput}
          />
          {!disabledElements && (
            <FixedSizeList
              height={height - 340}
              style={{ flexGrow: 1 }}
              itemCount={
                filter === ''
                  ? listTDoc.length
                  : listTDoc.filter(
                      r =>
                        r.tDocCodFor
                          .toLowerCase()
                          .replace(/\s+/g, '')
                          .includes(filter.toLowerCase().replace(/\s+/g, '')) ||
                        (
                          r.tDocCodFor.toLowerCase() +
                          '-' +
                          r.tDocNroFor
                            .toString()
                            .toLowerCase()
                            .replace(/\s+/g, '')
                        ).includes(filter.toLowerCase().replace(/\s+/g, '')) ||
                        r.tDocNroFor
                          .toString()
                          .toLowerCase()
                          .replace(/\s+/g, '')
                          .includes(filter.toLowerCase().replace(/\s+/g, '')) ||
                        r.codOri
                          .toString()
                          .toLowerCase()
                          .replace(/\s+/g, '')
                          .includes(filter.toLowerCase().replace(/\s+/g, ''))
                    ).length
              }
              itemSize={itemSize}
              width={'100%'}
            >
              {({ index, style }) => (
                <RenderRow
                  usuario={usuario}
                  index={index}
                  style={style}
                  listTDoc={listTDoc}
                  filter={filter}
                  checkPermisos={checkPermisos}
                  cambiarEstado={handlerState}
                  editar={handlerEdit}
                  verDetalles={handlerDetails}
                  eliminar={handlerDelete}
                  statesNEviables={stateNoEnviables}
                  sendToAPI={sendToAPI}
                  disabledElements={disabledElements}
                  cambiarGrupos={handlerGrupos}
                  globalSettings={globalSettings}
                />
              )}
            </FixedSizeList>
          )}
        </div>
        {selectedFilter && (
          <div className="modalReq">
            <AddFilter
              usuario={usuario}
              proveedores={proveedores}
              item={selectedFilter}
              cerrar={handlerClickFilter}
              filtro={filtros}
              aplicarFiltros={aplicarFiltros}
              workspace={activeWorkSpace}
              setFiltrosModificados={setFiltrosModificados}
            />
          </div>
        )}
        {selected && (
          <div className="modalReq">
            <ReqInfo
              item={selected.item}
              files={selected.files}
              cerrar={handlerDetails}
              verDetalle={verDetalle}
              repetir={repeat}
              generaPDF={generaPDF}
              abrirURL={handlerAbrirURL}
              guardarModificaciones={modificarEstado}
              usuario={usuario}
            />
          </div>
        )}
        {selectedRepeat && (
          <div className="modalReq">
            <FormReq
              edicion={'Guardar_Como'}
              req={selectedRepeat.item}
              itemList={selectedRepeat.nuevaListaP}
              productList={productList}
              guardarReq={guardarComo}
              cerrar={handlerRepeat}
              verDetalle={verDetalle}
            />
          </div>
        )}
        {selectedEdit && (
          <div className="modalReq">
            <FormReq
              edicion={'Edicion'}
              req={selectedEdit.req}
              itemList={selectedEdit.nuevaListaP}
              files={selectedEdit.files}
              guardarReq={editar}
              productList={productList}
              cerrar={handlerEdit}
              verDetalle={verDetalle}
            />
          </div>
        )}
        {selectedState && (
          <div className="modalReq">
            <StateChange
              item={selectedState}
              codFor={selectedState.tDocCodFor}
              nroFor={selectedState.tDocNroFor}
              guardarEstado={(r, state) => modificarEstado(r, { state: state })}
              cerrar={handlerState}
            />
          </div>
        )}
        {selectedGrupos && (
          <div className="modalReq">
            <GruposChange
              item={selectedGrupos}
              codFor={selectedGrupos.tDocCodFor}
              nroFor={selectedGrupos.tDocNroFor}
              guardarGrupos={(tDoc, gruposV) =>
                modificarGrupos(tDoc, { gruposV: gruposV })
              }
              data={gruposComprobanteSelected}
              cerrar={handlerGrupos}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default ReqList;
